import { useEffect, useState } from 'react';
import { Button } from '../components/ui/button.tsx';

const STORAGE_KEY = 'mb.theme';
type Theme = 'light' | 'dark';

function preferred(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyStoredTheme(): void {
  document.documentElement.classList.toggle('dark-mode', preferred() === 'dark');
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => preferred());

  useEffect(() => {
    document.documentElement.classList.toggle('dark-mode', theme === 'dark');
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <Button
      variant="tertiary"
      size="sm"
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      onPress={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
    >
      <span aria-hidden="true">{theme === 'dark' ? '☾' : '☀'}</span>
    </Button>
  );
}
